var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floater",style:({zIndex: _vm.zIndex})},[_c('transition',{attrs:{"name":_vm.transition},on:{"before-enter":_vm.beforeEnter,"enter":_vm.onEnter,"after-enter":_vm.afterEnter,"leave":_vm.onLeave,"after-leave":_vm.afterLeave}},[(_vm.mounted)?_vm._t("default"):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b6183de","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Helpers/Overlay.vue
// module id = null
// module chunks = 